import React, { Fragment, useState, useEffect, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { utils } from "../common/utils";
import { waveform, lineWobble, bouncy, infinity } from 'ldrs'
import { useDidRecover } from 'react-router-cache-route';

let autoComplete;
const defaultComponentForm = {
    street_number: { nameFormat: "short_name", mappedField: "address1" },
    route: { nameFormat: "long_name", mappedField: "address1" }, 
    neighborhood: { nameFormat: "long_name", mappedField: "address2" }, 
    locality: { nameFormat: "long_name", mappedField: "address3" }, 
    postal_town: { nameFormat: "long_name", mappedField: "address3" }, 
    administrative_area_level_1: { nameFormat: "long_name", mappedField: "address4" }, 
    administrative_area_level_2: { nameFormat: "long_name", mappedField: "address4" }, 
    country: { nameFormat: "long_name", mappedField: "country" }, 
    postal_code: { nameFormat: "short_name", mappedField: "postCode" },
    // countryIsoCode: { nameFormat: "short_name", mappedField: "countryIsoCode"}
};

const addressFormMap = {
    street_number: "address1", // address1
    route: "address1", // address1
    neighborhood: "address2", // address2
    locality: "address3", //City - In CA
    postal_town: "address3", // City- IN UK
    administrative_area_level_1: "address4", //State
    administrative_area_level_2: "address4", //County
    country: "country", //country
    postal_code: "postCode", // postal_code
};


const loadGooglePlacesAutocompleteScript = async (scriptContent, callback, setHasLoaded) => {

    if (window.google && window.google.maps && window.google.maps.places) {

        callback();
        return
    }

    utils.injectScript(scriptContent);

    if (window.google && window.google.maps) {
       await window.google.maps.importLibrary("places");
       if(window.google.maps.places)

            callback();

    }
    //let script = document.createElement("script");
    //script.type = "text/javascript";

    //if (script.readyState) {
    //    script.onreadystatechange = function () {
    //        if (script.readyState === "loaded" || script.readyState === "complete") {
    //            script.onreadystatechange = null;
    //            callback();
    //        }
    //    };
    //} else {
    //    script.onload = () => callback();
    //}

    //script.src = url;
    //document.getElementsByTagName("head")[0].appendChild(script);
};

function handleGooglePlacesAutocompleteScriptLoad(updateQuery, settings, onChangeCallback, autoCompleteRef, setHasLoaded) {
    let componentRestrictions = {};
    let countryFilter = settings.googleGeoFilterCountriesCodes && settings.googleGeoFilterCountriesCodes != "" ? settings.googleGeoFilterCountriesCodes.split(",") : settings.isoCode;
    if (settings.isoCode) {
      componentRestrictions = { country: countryFilter };
    }
    autoComplete = new window.google.maps.places.Autocomplete(
        autoCompleteRef.current,
        { componentRestrictions: componentRestrictions}
    );
    autoComplete.setFields(["address_components", "formatted_address", "geometry"]);
    autoComplete.addListener("place_changed", () => handlePlaceSelect(updateQuery, onChangeCallback, settings) );

        setTimeout(
            function () {
                if (autoCompleteRef && autoCompleteRef.current) {
                    autoCompleteRef.current.setAttribute("autocomplete", "nop");
                }
                setHasLoaded(true);
            }, 1000 );

}




async function handlePlaceSelect(updateQuery, onChangeCallback, settings) {
    const addressObject = autoComplete.getPlace();
    const query = addressObject.formatted_address;
    updateQuery(query);
    // set the geomtry fields
    let lat;
    let lng;
    if(addressObject && addressObject.geometry && addressObject.geometry.location) {
        lat = addressObject.geometry.location.lat();
        lng = addressObject.geometry.location.lng();
    }
    var mappedAddress = { address1: "", address2: "", address3: "", address4: "", postCode: "", country: "", countryIsoCode: "", lat, lng, formatted_address: addressObject.formatted_address }
    const componentForm = settings.googleAutocompleteAddressFormat || defaultComponentForm;
     //Get each component of the address from the place details,
     //and then fill-in the corresponding field on the form.
    for (const component of addressObject.address_components) {
        const addressType = component.types[0];
        
        if (addressType === "country") {
            mappedAddress["countryIsoCode"] = component["short_name"];
        }

        const selectedComponent = utils.getPropCaseInsensitive(componentForm, addressType);
        if (selectedComponent) {
            const nameFormatProp = utils.getPropCaseInsensitive(selectedComponent, "nameFormat");
            const val = utils.getPropCaseInsensitive(component, nameFormatProp);

            let mappedAddressProperty = utils.getPropCaseInsensitive(selectedComponent, "mappedField");
            if (mappedAddressProperty) {
                const currentVal = utils.getPropCaseInsensitive(mappedAddress, mappedAddressProperty);
                const newValue = `${currentVal}${(utils.isNullOrEmpty(currentVal) === true || mappedAddressProperty === addressFormMap.street_number ? "" : ", ") } ${ val }`;
                utils.setPropCaseInsensitive(mappedAddress, mappedAddressProperty, newValue);
            }
        }
    }
    if (onChangeCallback) {
        onChangeCallback(mappedAddress)
    }

}

function GoogleAddressAutoComplete(props) {
    const [query, setQuery] = useState(props.initialValue ? props.initialValue : "");
    const autoCompleteRef = useRef(null);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [hasReloaded, setHasReloaded] = useState(false);
    const { t } = useTranslation();
    
    useEffect(() => {
        infinity.register()
        loadGooglePlacesAutocompleteScript(
            `(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=\`https://maps.\${c}apis.com/maps/api/js?\`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
                key: "${props.settings.googleKey}",
                v: "weekly",
              })`,
            () => handleGooglePlacesAutocompleteScriptLoad(setQuery, props.settings, props.onChange, autoCompleteRef, setHasLoaded),
            setHasLoaded
        );
    }, [hasReloaded]);

    useDidRecover(() => {
        setHasReloaded(prevState => !prevState);
    });

    // added this since the normal callback gets called only on autocomplete finished, if the user removes the entry the address does not get updated to empty instead of the prev formatted address
    // maybe later we can fix this issue for all other calls as well not just isRequired
    useEffect(() => {
        if(props.isRequired) {
            props.onChange({ formatted_address: query })
        }
            
    }, [query]);

    return (


        // Default values shown

        <Fragment>
        {!hasLoaded &&
        <div className="d-flex justify-content-center">
            <l-infinity
            size="100"
            stroke="10"
            speed="1"
            color="#0da9ef"
            ></l-infinity>
        </div>
        }
            <div className="row" style={{ display: !hasLoaded ? 'none' : null }}>
                    <div className="col-sm-12">
                        <div className={"form-group"}>
                            <label htmlFor="Address">{t("Address")}</label>
                            {props.isRequired && <span className="red">*</span>}
                            <span className={`${props.isRequired && props.touched && props.error ? "has-danger" : ""}`}>
                                <input
                                    //required={props.isRequired}
                                    
                                    style={ props.isRequired && props.touched && props.error ?{
                                        borderColor: '#ff5252', 
                                        backgroundImage: 'url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDI0MS4xNzEgMjQxLjE3MSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjQxLjE3MSAyNDEuMTcxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCI+CjxnPgoJPHBhdGggaWQ9IkNsb3NlIiBkPSJNMTM4LjEzOCwxMjAuNzU0bDk5LjExOC05OC41NzZjNC43NTItNC43MDQsNC43NTItMTIuMzE5LDAtMTcuMDExYy00Ljc0LTQuNzA0LTEyLjQzOS00LjcwNC0xNy4xNzksMCAgIGwtOTkuMDMzLDk4LjQ5MkwyMS4wOTUsMy42OTljLTQuNzQtNC43NTItMTIuNDM5LTQuNzUyLTE3LjE3OSwwYy00Ljc0LDQuNzY0LTQuNzQsMTIuNDc1LDAsMTcuMjI3bDk5Ljg3Niw5OS44ODhMMy41NTUsMjIwLjQ5NyAgIGMtNC43NCw0LjcwNC00Ljc0LDEyLjMxOSwwLDE3LjAxMWM0Ljc0LDQuNzA0LDEyLjQzOSw0LjcwNCwxNy4xNzksMGwxMDAuMTUyLTk5LjU5OWw5OS41NTEsOTkuNTYzICAgYzQuNzQsNC43NTIsMTIuNDM5LDQuNzUyLDE3LjE3OSwwYzQuNzQtNC43NjQsNC43NC0xMi40NzUsMC0xNy4yMjdMMTM4LjEzOCwxMjAuNzU0eiIgZmlsbD0iI2ZmNTI1MiIvPgoJPGc+Cgk8L2c+Cgk8Zz4KCTwvZz4KCTxnPgoJPC9nPgoJPGc+Cgk8L2c+Cgk8Zz4KCTwvZz4KCTxnPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=)',
                                        backgroundPosition: 'center right 15px',
                                        backgroundSize: '13px 13px',
                                        backgroundRepeat: 'no-repeat'
                                    } : {}}
                                    ref={autoCompleteRef}
                                    onChange={event => setQuery(event.target.value)}
                                    placeholder={t("Type your address")}
                                    value={query}
                                />
                                {/* <span className="form-group">
                                    <span className="input-group">
                                        <span className="input-group-addon">
                                            <i className="pe-7s-map-marker mr-1"> </i>{" "}
                                        </span>
                                    </span>
                                    
                                </span> */}
                                {props.isRequired && props.touched && ((props.error && <span className="form-control-feedback">{props.error}</span>) || (props.warning && <span>{props.warning}</span>))}
                            </span>
                        </div>
                    </div>
                </div>
        </Fragment>


    );
}

export default GoogleAddressAutoComplete;
